import { KycFailureReason } from '@/api/queryHooks/useKycController';

// RNB-195: single source of truth for the user-facing "why your KYC needs attention" copy,
// reused wherever we prompt the user to (re)verify — the re-verify modal, the profile status,
// and the verification result screens.
export function getKycFailureText(
  reason?: KycFailureReason | null,
  message?: string | null,
): string | null {
  if (reason === 'DUPLICATE_ACCOUNT') {
    return 'This ID already has a RelayPay account. If you believe this is a mistake, please contact support@relaypay.io.';
  }
  return message || null;
}
